{
  "breaches": {
    "count": "Jouw accountgegevens zijn gelekt in {count} datalekken.",
    "discovered": "Dit datalek werd voor het eerst ontdekt op {date}.",
    "empty": {
      "text": "We hebben geen datalekken gevonden voor jouw account.",
      "title": "Geen datalekken gevonden"
    },
    "high": "Hoog",
    "medium": "Gemiddeld",
    "title": "Datalekken",
    "watchlist": {
      "button": "E-mailadres toevoegen",
      "text": "E-mailadressen die worden gemonitord",
      "title": "Watchlist"
    }
  },
  "cards": {
    "breaches": {
      "text": "Op deze pagina kun je het aantal datalekken controleren waarbij jouw account betrokken is geweest. We categoriseren de datalekken op basis van hun ernst en het type gegevens dat is gelekt. Zorg ervoor dat je jouw wachtwoorden wijzigt als je gegevens zijn blootgesteld in een datalek.",
      "title": "Zijn jouw gegevens gelekt?"
    },
    "overview": {
      "text": "Hallo {name}! Zoals je wellicht weet, worden phishingaanvallen steeds complexer en gevaarlijker. De Hub is de plek om jouw voortgang bij te houden en nog meer te leren over de cyberaanvallen die jouw organisatie bedreigen. Voltooi beveiligingsprestaties en word in een mum van tijd een beveiligingsexpert.",
      "title": "Welkom bij The Hub!"
    },
    "quiz": {
      "text": "Ga op interactieve quizreis en test je vaardigheden om onderscheid te maken tussen echte en phishing-e-mails. De quiz is ontworpen om jouw kennis en begrip van bedreigingen die in de echte wereld bestaan te testen.",
      "title": "Laten we je testen!"
    },
    "simulations": {
      "text": "Op deze pagina kun je de details bekijken van de simulaties die je de afgelopen 90 dagen van Moxso hebt ontvangen. Door te begrijpen hoe phishing-e-mails zijn ontworpen, kun je ze identificeren en jezelf ertegen beschermen.",
      "title": "Ben je gephisht?"
    },
    "videos": {
      "text": "Op deze pagina kun je video's bekijken over de nieuwste cyberbedreigingen en leren hoe je jezelf en jouw organisatie ertegen kunt beschermen. Onze trainingsvideo's zijn beschikbaar om te bekijken wanneer je maar wilt.",
      "title": "Klaar voor actie!"
    }
  },
  "certificate": {
    "certificate_of_completion": "Certificaat van voltooiing",
    "certificate_unlocked": "Certificaat ontgrendeld",
    "share_on_linkedin": "Delen op LinkedIn",
    "show_certificate": "Certificaat tonen",
    "text": "Je hebt een certificaat van een recente cursus. Deel je behaalde certificaten met je netwerk!"
  },
  "courses": {
    "all": "Alle cursussen",
    "completed": {
      "badge": "Voltooid",
      "button": "Cursus voltooien",
      "text": "Je hebt de cursus voltooid",
      "title": "Goed gedaan!"
    },
    "content": {
      "breach": {
        "text": "Schakel datalekdetectie in voor jouw account",
        "title": "Datalekdetectie instellen"
      },
      "download": {
        "button": "Downloaden"
      },
      "introduction": {
        "contents": "Inhoud",
        "start": "Cursus starten",
        "text": "Cursusintroductie en overzicht",
        "title": "Introductie"
      },
      "quiz": {
        "choose_answer": "Kies het juiste antwoord hieronder:",
        "correct": "Correct",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Juiste antwoord",
        "next_question": "Volgende vraag",
        "oh_no": "Helaas!",
        "question_of": "Vraag {current} van {total}",
        "result": {
          "button": "Quiz voltooien",
          "text": "Je hebt {correct} van de {total} vragen correct beantwoord.",
          "title": "Goed gedaan!",
          "title_fail": "Bijna goed!"
        },
        "text": "Test je vaardigheden met een quiz",
        "title": "Quiz",
        "view_results": "Resultaat bekijken",
        "well_done": "Goed gedaan!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Jouw antwoord"
      },
      "video": {
        "text": "Leer de belangrijkste concepten door deze video te bekijken"
      }
    },
    "continue": "Doorgaan",
    "featured": "Aanbevolen cursussen",
    "lessons": "{count} lessen",
    "progress": {
      "button": "Doorgaan",
      "text": "Je hebt {pct}% van deze cursus voltooid"
    },
    "skip_video": {
      "button": "Overslaan",
      "text": "Je hebt deze video eerder bekeken. Overslaan?"
    },
    "start_over": "Opnieuw beginnen",
    "title": "Cursussen"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "De vraag is verlopen",
        "network": "Er is een fout opgetreden",
        "noResponse": "Geen reactie ontvangen van de server",
        "streaming": {
          "manifest": "Er is een fout opgetreden bij het afspelen van de video",
          "platform": "Deze video wordt niet ondersteund op jouw apparaat",
          "unavailable": "Deze video is niet beschikbaar"
        },
        "unknown": "Er is een onbekende fout opgetreden"
      },
      "messages": {
        "auth_failed": "Ongeldig e-mailadres",
        "csrf": "Ververs de pagina en probeer het opnieuw",
        "email_missing": "Geen e-mailadres gekoppeld aan account",
        "file_not_found": "Bestand niet gevonden",
        "general_exception": "Er is een fout opgetreden",
        "invalid_answer": "Ongeldig antwoord",
        "invalid_course": "Ongeldige cursus",
        "invalid_domain": "Ongeldig domein",
        "invalid_email": "Ongeldig e-mailadres",
        "invalid_grant": "Kon geen contact maken met de provider",
        "invalid_locale": "Vertaling niet gevonden",
        "invalid_option": "Ongeldige optie",
        "invalid_permissions": "Je bent niet geautoriseerd om deze functie te gebruiken",
        "invalid_point": "Ongeldig punt",
        "invalid_provider": "Ongeldige provider",
        "invalid_quiz": "Ongeldige quiz",
        "invalid_token": "Je sessie is verlopen",
        "invalid_video": "Ongeldige video",
        "missing_code": "Probeer het opnieuw",
        "two_factor_code_expired": "Tweefactorauthenticatiecode verlopen",
        "two_factor_code_invalid": "Tweefactorauthenticatiecode is ongeldig",
        "unauthorized": "Je bent niet geautoriseerd om deze functie te gebruiken",
        "user_not_found": "De gebruiker bestaat niet"
      },
      "validations": {
        "messages": {
          "throttle": "Te veel inlogpogingen. Probeer het later opnieuw."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Rekeningoverzicht",
        "address_book_contacts": "Adresboekcontacten",
        "age_groups": "Leeftijdsgroepen",
        "ages": "Leeftijden",
        "appointments": "Afspraken",
        "apps_installed_on_devices": "Apps geïnstalleerd op apparaten",
        "astrological_signs": "Astrologische tekens",
        "audio_recordings": "Audio-opnames",
        "auth_tokens": "Authenticatietokens",
        "avatars": "Avatars",
        "bank_account_numbers": "Bankrekeningnummers",
        "beauty_ratings": "Schoonheidsbeoordelingen",
        "biometric_data": "Biometrische gegevens",
        "bios": "Biografie",
        "browser_user_agent_details": "Browser gebruiker agent-details",
        "browsing_histories": "Browsegeschiedenis",
        "buying_preferences": "Koopvoorkeuren",
        "car_ownership_statuses": "Eigendomsstatus auto",
        "career_levels": "Carrièreniveaus",
        "cellular_network_names": "Mobiele netwerknamen",
        "charitable_donations": "Liefdadigheidsdonaties",
        "chat_logs": "Chatlogboeken",
        "credit_card_cvv": "Creditcard CVV",
        "credit_cards": "Creditcards",
        "credit_status_information": "Kredietstatusinformatie",
        "customer_feedback": "Klantfeedback",
        "customer_interactions": "Klantinteracties",
        "dates_of_birth": "Geboortedata",
        "deceased_date": "Overlijdensdatum",
        "deceased_statuses": "Overlijdensstatus",
        "device_information": "Apparaatinformatie",
        "device_serial_numbers": "Serienummers van apparaten",
        "device_usage_tracking_data": "Gegevens over apparaatgebruik",
        "drinking_habits": "Drinkgewoonten",
        "driver_s_licenses": "Rijbewijzen",
        "drug_habits": "Drugsgewoonten",
        "eating_habits": "Eetgewoonten",
        "education_levels": "Opleidingsniveaus",
        "email_addresses": "E-mailadressen",
        "email_messages": "E-mailberichten",
        "employers": "Werkgevers",
        "employment_statuses": "Werkgelegenheidsstatus",
        "encrypted_keys": "Versleutelde sleutels",
        "ethnicities": "Etniciteiten",
        "family_members_names": "Namen van familieleden",
        "family_plans": "Gezinsplannen",
        "family_structure": "Gezinsstructuur",
        "financial_investments": "Financiële investeringen",
        "financial_transactions": "Financiële transacties",
        "fitness_levels": "Fitnessniveaus",
        "genders": "Geslachten",
        "geographic_locations": "Geografische locaties",
        "government_issued_i_ds": "Door de overheid uitgegeven identiteitsbewijzen",
        "health_insurance_information": "Ziektekostenverzekeringsinformatie",
        "historical_passwords": "Historische wachtwoorden",
        "hiv_statuses": "HIV-status",
        "home_loan_information": "Informatie over hypotheek",
        "home_ownership_statuses": "Woningbezitsstatus",
        "homepage_ur_ls": "Homepage-URL's",
        "imei_numbers": "IMEI-nummers",
        "imsi_numbers": "IMSI-nummers",
        "income_levels": "Inkomensniveaus",
        "instant_messenger_identities": "Instant messenger-identiteiten",
        "ip_addresses": "IP-adressen",
        "job_applications": "Sollicitaties",
        "job_titles": "Functietitels",
        "licence_plates": "Nummerplaten",
        "living_costs": "Levenskosten",
        "login_histories": "Inloggeschiedenis",
        "mac_addresses": "MAC-adressen",
        "marital_statuses": "Burgerlijke staat",
        "mnemonic_phrases": "Geheugensteunzinnen",
        "mothers_maiden_names": "Meisjesnamen van moeders",
        "names": "Namen",
        "nationalities": "Nationaliteiten",
        "net_worths": "Nettovermogen",
        "nicknames": "Bijnamen",
        "occupations": "Beroepen",
        "parenting_plans": "Opvoedingsplannen",
        "partial_credit_card_data": "Gedeeltelijke creditcardgegevens",
        "partial_dates_of_birth": "Gedeeltelijke geboortedata",
        "passport_numbers": "Paspoortnummers",
        "password_hints": "Wachtwoordhints",
        "password_strengths": "Wachtwoordsterkte",
        "passwords": "Wachtwoorden",
        "payment_histories": "Betalingsgeschiedenis",
        "payment_methods": "Betaalmethoden",
        "personal_descriptions": "Persoonlijke beschrijvingen",
        "personal_health_data": "Persoonlijke gezondheidsgegevens",
        "personal_interests": "Persoonlijke interesses",
        "phone_numbers": "Telefoonnummers",
        "photos": "Foto's",
        "physical_addresses": "Fysieke adressen",
        "physical_attributes": "Fysieke kenmerken",
        "pi_ns": "Pincodes",
        "places_of_birth": "Geboorteplaatsen",
        "political_donations": "Politieke donaties",
        "political_views": "Politieke opvattingen",
        "private_messages": "Privéberichten",
        "professional_skills": "Professionele vaardigheden",
        "profile_photos": "Profielfoto's",
        "purchases": "Aankopen",
        "purchasing_habits": "Koopgewoonten",
        "races": "Afkomst",
        "recovery_email_addresses": "Herstel-e-mailadressen",
        "relationship_statuses": "Relatiestatus",
        "religions": "Religies",
        "reward_program_balances": "Saldo's van beloningsprogramma's",
        "salutations": "Aanhef",
        "school_grades_class_levels": "Schoolcijfers (klasniveaus)",
        "security_questions_and_answers": "Beveiligingsvragen en antwoorden",
        "sexual_fetishes": "Seksuele fetisjen",
        "sexual_orientations": "Seksuele geaardheid",
        "smoking_habits": "Rookgewoonten",
        "sms_messages": "SMS-berichten",
        "social_connections": "Sociale connecties",
        "social_media_profiles": "Social media-profielen",
        "social_security_numbers": "Burgerservicenummers",
        "spoken_languages": "Gesproken talen",
        "spouses_names": "Namen van echtgenoten",
        "support_tickets": "Supporttickets",
        "survey_results": "Enquêteresultaten",
        "taxation_records": "Belastinggegevens",
        "telecommunications_carrier": "Telecommunicatieaanbieder",
        "time_zones": "Tijdzones",
        "travel_habits": "Reisgewoonten",
        "user_statuses": "Gebruikersstatus",
        "user_website_ur_ls": "Gebruikerswebsite-URL's",
        "usernames": "Gebruikersnamen",
        "utility_bills": "Nutsrekeningen",
        "vehicle_details": "Voertuiggegevens",
        "website_activity": "Websiteactiviteit",
        "work_habits": "Werkgewoonten",
        "years_of_professional_experience": "Jaren professionele ervaring"
      }
    },
    "certificates": {
      "compliance": "Cybersecuritytraining"
    },
    "courses": {
      "toc": {
        "breach-content": "Datalekken",
        "file-content": "Downloaden",
        "intro-content": "Introductie",
        "quiz-content": "Quiz",
        "text-content": "Case",
        "video-content": "Video"
      }
    },
    "locales": {
      "current": "Nederlands",
      "da_DK": "Deens",
      "de_DE": "Duits",
      "en_US": "Engels",
      "es_ES": "Spaans",
      "fi_FI": "Fins",
      "fr_FR": "Frans",
      "nb_NO": "Noors",
      "nl_NL": "Nederlands",
      "pl_PL": "Pools",
      "pt_PT": "Portugees",
      "sv_SE": "Zweeds"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Hallo en welkom bij jouw persoonlijke leerplatform! We zijn heel blij dat je jezelf bij ons aansluit en staan klaar om je te helpen jouw leerdoelen te bereiken.",
              "title": "Welkom bij Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Hoe Moxso werkt",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Laten we beginnen 🙌\n",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Bewustzijn van gegevensprivacy",
          "options": {
            "high": "Bekend",
            "low": "Niet bekend",
            "medium": "Enigszins bekend"
          },
          "question": "Hoe bekend bent u met de basisprincipes van gegevensprivacy (bijv. AVG)?"
        },
        "device_security": {
          "category": "Apparaatbeveiligingspraktijken",
          "options": {
            "high": "Ja, altijd",
            "low": "Nee, nooit",
            "medium": "Soms"
          },
          "question": "Update je  regelmatig je apparaten en gebruik je beveiligingstools zoals een VPN?"
        },
        "digital_threats": {
          "category": "Bewustzijn van digitale bedreigingen",
          "options": {
            "high": "Bekend",
            "low": "Niet bekend",
            "medium": "Enigszins bekend"
          },
          "question": "Hoe bekend ben je met digitale bedreigingen zoals malware, phishing en ransomware?"
        },
        "hybrid_work": {
          "category": "Beveiliging bij thuiswerken",
          "options": {
            "high": "Zeer zelfverzekerd",
            "low": "Niet zelfverzekerd",
            "medium": "Enigszins zelfverzekerd"
          },
          "question": "Hoe zelfverzekerd ben je bij het handhaven van beveiliging bij het op afstand werken (bijv. op openbare wifi)?"
        },
        "incidents_breaches": {
          "category": "Incidentrapportage",
          "options": {
            "high": "Ja",
            "low": "Nee",
            "medium": "Ik heb een algemeen idee"
          },
          "question": "Ken je de juiste procedure voor het melden van een beveiligingsincident of datalek?"
        },
        "passwords_accounts": {
          "category": "Wachtwoordbeheer",
          "options": {
            "high": "Ik gebruik een wachtwoordbeheerder",
            "low": "Ik hergebruik wachtwoorden",
            "medium": "Ik maak unieke, sterke wachtwoorden"
          },
          "question": "Hoe beheer je wachtwoorden voor jouw werkgerelateerde accounts?"
        },
        "phishing": {
          "category": "Identificatie van phishing",
          "options": {
            "high": "Zeer zelfverzekerd",
            "low": "Niet zelfverzekerd",
            "medium": "Enigszins zelfverzekerd"
          },
          "question": "Hoe zelfverzekerd ben je in het herkennen van phishingpogingen in e-mails of berichten?"
        },
        "physical_security": {
          "category": "Praktijken voor fysieke beveiliging",
          "options": {
            "high": "Altijd",
            "low": "Zelden",
            "medium": "Soms"
          },
          "question": "Hoe vaak beveilig je jouw werkplek (bijv. uw computer vergrendelen, gevoelige documenten opbergen)?"
        },
        "secure_browsing": {
          "category": "Veilige browsgewoonten",
          "options": {
            "high": "Ja, altijd",
            "low": "Nee, nooit",
            "medium": "Soms"
          },
          "question": "Vermijd je het gebruik van openbare wifi of het klikken op verdachte links tijdens het browsen?"
        }
      },
      "steps": {
        "finished": "Voltooid",
        "introduction": "Introductie",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "cancer": "Danish Cancer Society",
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Ongeldige controlesom",
        "option": "Antwoord niet herkend"
      },
      "intro": {
        "button": "Quiz starten",
        "text": "We gaan door 5 e-mails in je Moxso-inbox. Sommige e-mails kunnen van oplichters zijn die toegang proberen te krijgen tot gevoelige gegevens - je moet beslissen of de e-mail phishing is of niet. Ben je er klaar voor?",
        "title": "Klaar om te rapporteren?"
      },
      "multiple-choice": {
        "heading": "Vind de fout in deze e-mail",
        "text": "hulptekst voor meerkeuzevragen"
      },
      "options": {
        "email": "De e-mail",
        "false": "Dit is GEEN phishing",
        "help": {
          "email": "De afzender is NIET vertrouwd",
          "false": "E-mail moet NIET worden gerapporteerd",
          "link": "De link leidt NIET naar een betrouwbare bestemming",
          "not-phishing": "Dit is GEEN phishing",
          "true": "E-mail moet worden gerapporteerd"
        },
        "link": "De link",
        "not-phishing": "Dit is GEEN phishing",
        "true": "Dit IS phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Is dit een phishing-e-mail?",
        "text": "Bepaal of dit een phishing-e-mail is of niet"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Deze cursus is niet toegankelijk. Optionele cursussen zijn vergrendeld, maar verplichte training is altijd beschikbaar.",
          "title": "Cursuslimiet bereikt"
        },
        "quiz": {
          "description": "Je hebt je trainingslimiet bereikt. Optionele quizzen zijn voorlopig vergrendeld.",
          "title": "Quizlimiet bereikt"
        },
        "video": {
          "description": "Je hebt je trainingslimiet bereikt. Optionele video's zijn vergrendeld, maar verplichte training blijft altijd beschikbaar.",
          "title": "Videolimiet bereikt"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Deze cursus is niet toegankelijk. Optionele cursussen zijn vergrendeld, maar verplichte training is altijd beschikbaar.",
        "title": "Cursuslimiet bereikt"
      },
      "quiz": {
        "description": "Je hebt je trainingslimiet bereikt. Optionele quizzen zijn voorlopig vergrendeld.",
        "title": "Quizlimiet bereikt"
      },
      "reset": "Wordt maandag gereset",
      "video": {
        "description": "Je hebt je trainingslimiet bereikt. Optionele video's zijn vergrendeld, maar verplichte training blijft altijd beschikbaar.",
        "limit_reached": "Limiet bereikt",
        "title": "Videolimiet bereikt"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "Geavanceerd is een serie voor iedereen die dieper wil duiken in cyberbeveiliging en wil begrijpen hoe de onderliggende mechanismen van hacken, aanvallen en verdediging werken. Als je alleen een basiskennis van cyberbeveiliging nodig hebt, hoef je deze serie niet te bekijken. Wil je echter meer leren over hacken, cyberaanvallen en hoe je jouw digitale veiligheid verder kunt versterken, dan ben je hier precies op de juiste plek.",
          "title": "Geavanceerd",
          "tooltip": "Word in een mum van tijd een hackingexpert"
        },
        "ai": {
          "text": "De AI-serie gaat in op de ingewikkelde rol van kunstmatige intelligentie in cyberbeveiliging. AI dient een dubbel doel: het is een cruciaal hulpmiddel voor IT-beveiligingsprofessionals om bedreigingen te identificeren en te bestrijden, terwijl het ook een krachtig wapen is in handen van hackers. Deze videoserie is bedoeld om je bewustzijn van door AI gegenereerde phishingschema's te vergroten en je te begeleiden bij het veilig inzetten van AI om fouten te minimaliseren en het risico op hacken te verlagen. Uiteindelijk benadrukt de serie dat hoewel AI een krachtig hulpmiddel is voor zowel verdedigers als aanvallers, jouw gedrag de belangrijkste factor blijft in je beveiliging.",
          "title": "AI en cyberbeveiliging",
          "tooltip": "Verken de complexe rol van AI in cyberbeveiliging"
        },
        "compliance": {
          "text": "In deze categorie vind je video's over belangrijke wetgeving, beveiligingsstandaarden en certificeringen die helpen jouw organisatie te beschermen tegen digitale bedreigingen. De video's leggen op een begrijpelijke manier uit wat richtlijnen zoals NIS2 en DORA inhouden, waarom ze belangrijk zijn en welke maatregelen organisaties moeten nemen om aan deze eisen te voldoen. Je krijgt inzicht in wat deze regelgeving betekent voor jouw dagelijkse werk, hoe naleving eruitziet en waarom het de moeite waard is om ermee vertrouwd te raken.",
          "title": "Certificeringen en compliance",
          "tooltip": "Begrijp het belang van certificeringen en compliance"
        },
        "gdpr": {
          "text": "De AVG-serie geeft je een helder overzicht van de belangrijkste regels, eisen en principes uit de Algemene Verordening Gegevensbescherming. Sinds de invoering in 2018 moeten alle organisaties voldoen aan deze wet om de integriteit en bescherming van persoonsgegevens te waarborgen. In deze serie leer je de meest relevante onderdelen van de AVG kennen, zodat je weet hoe je persoonsgegevens op een correcte en veilige manier verwerkt in jouw dagelijkse werk. De video's zijn bedoeld voor iedereen die met persoonsgegevens werkt, waaronder medewerkers in de particuliere sector.",
          "title": "AVG",
          "tooltip": "Leer de belangrijkste vereisten en regels in de AVG en hoe je deze in jouw dagelijks leven kunt naleven"
        },
        "hacking": {
          "text": "Het leven van een hacker is een serie die je leert over de mensen achter cyberaanvallen, de hackers van de wereld. We zullen enkele van de methoden die hackers gebruiken om online anoniem te blijven en hoe ze hun geld verdienen nader bekijken. De video's zullen verder de verschillende soorten hackers uitleggen en waarom ze zo moeilijk te pakken zijn.",
          "title": "Het leven van een hacker",
          "tooltip": "Leer de mensen achter cyberaanvallen kennen, de hackers van de wereld"
        },
        "money_laundering": {
          "text": "Witwassen is een serie die ingaat op de verschillende methoden die criminelen gebruiken om geld wit te wassen. De video's zullen de verschillende methoden uitleggen die criminelen gebruiken om geld wit te wassen en hoe witwassen kan worden opgespoord en voorkomen.",
          "title": "Witwassen",
          "tooltip": "Leer de verschillende methoden kennen die criminelen gebruiken om geld wit te wassen en hoe witwassen kan worden opgespoord en voorkomen"
        },
        "phishing": {
          "text": "Deze serie gaat in op de meest voorkomende cyberaanval ter wereld: Phishing. Een phishingaanval kan op zichzelf staan, maar wordt ook vaak gebruikt als opstap naar complexere cyberaanvallen. Het is bovendien een type aanval waarbij jij als werknemer een belangrijke rol speelt in het voorkomen van schade, bijvoorbeeld door alert te zijn op verdachte e-mails en niet zomaar op links te klikken. Deze serie behandelt waarom phishing een cruciaal thema is binnen cyberbeveiliging en laat zien hoe aanvallen worden uitgevoerd en hoe je kunt voorkomen dat je slachtoffer wordt.",
          "title": "Phishing",
          "tooltip": "Ontdek de aspecten van de meest voorkomende cyberaanval wereldwijd"
        },
        "physical_security": {
          "text": "Fysieke beveiliging is een serie die het belang van goede beveiliging op de werkplek en thuis benadrukt. Cyberbeveiliging gaat over meer dan de beveiliging van je apparaten, het gaat ook om de beveiliging rondom de apparaten. Veel mensen zijn bekend met thuiswerken, en we rusten je uit om dit zo veilig mogelijk te maken. Bovendien krijg je met deze serie inzicht in alles van bezoekbeheer tot cyberbeveiliging op mobiele apparaten en de risico's van het gebruik van openbare netwerken.",
          "title": "Fysieke beveiliging",
          "tooltip": "Leer waarom fysieke beveiliging een cruciaal element is in goede cyberbeveiliging"
        },
        "tips_and_tricks": {
          "text": "In deze serie zal je tips en tricks leren die je zullen helpen om jouw cyberbeveiliging te verhogen. Je leert specifieke, praktische manieren om jouw persoonlijke online beveiliging te verhogen om vervolgens hiermee de beveiliging op je werkplek te verbeteren. Hiernaast zullen de video’s uitleggen waarom het belangrijk is om het advies.",
          "title": "Tips en trucs",
          "tooltip": "Leer hoe je jouw persoonlijke cyberbeveiliging kunt verhogen"
        },
        "types_of_hacking": {
          "text": "Soorten hacks is een serie die je inzicht geeft in de verschillende methoden die hackers tot hun beschikking hebben wanneer ze je proberen te misleiden. Elke aflevering geeft je een basiskennis van de kenmerken van een specifieke hackmethode, wat de hackers kunnen winnen door die methode te gebruiken, de gevolgen die het voor je kan hebben als je wordt gehackt, enz. Door de video's in deze serie te bekijken, ben je beter voorbereid tegen hackingaanvallen in de toekomst.",
          "title": "Soorten hacks",
          "tooltip": "Krijg inzicht in de verschillende methoden die door hackers worden gebruikt"
        },
        "uploads": {
          "text": "Deze categorie bevat aangepaste video's die door jouw organisatie zijn geüpload.",
          "title": "Uploads",
          "tooltip": "Bekijk video's geüpload door jouw organisatie voor jouw specifieke beveiligingsbehoeften"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Fout is gerapporteerd aan ons team met id: {errorId}.\n Als je onmiddellijke hulp nodig hebt, neem dan gerust contact op met ons supportteam op support{'@'}moxso.com.",
    "go_back": "Terug naar home",
    "text": "Er is een onbekende fout opgetreden en we konden jouw verzoek niet voltooien. Onze excuses voor het ongemak. Probeer het later opnieuw.",
    "title": "Er is iets misgegaan"
  },
  "forms": {
    "fields": {
      "code": "Eenmalig wachtwoord",
      "email": "E-mail"
    },
    "placeholders": {
      "email": "naam{'@'}bedrijf.com"
    }
  },
  "loading": "Laden",
  "locale": {
    "current": "Nederlands",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Inloggen",
      "next": "Volgende",
      "send_one_time_code": "Eenmalige code verzenden",
      "try_again": "Code opnieuw verzenden"
    },
    "choose_provider": "Provider kiezen",
    "loading": "Laden",
    "sso": {
      "validating": "SSO wordt gecontroleerd"
    },
    "title": "Inloggen",
    "two_factor": {
      "text": "We hebben een eenmalig wachtwoord naar je e-mailadres gestuurd.",
      "title": "Controleer je e-mail"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Je hebt de aanbevolen inhoud voltooid die door jouw beheerder voor jou is gekozen.",
      "title": "Goed gedaan!"
    },
    "deadline": "Voltooiingsdeadline: {date}",
    "next_training": "Volgende verplichte training",
    "policy_fallback_title": "Beleid",
    "quiz_questions": "{count} vraag | {count} vragen",
    "retake": "Opnieuw toegewezen",
    "start_quiz": "Quiz starten",
    "text": "Jouw verplichte training",
    "title": "Verplichte training",
    "view_policy": "Beleid bekijken"
  },
  "navigation": {
    "breaches": "Datalekken",
    "courses": "Cursussen",
    "exit": "Afsluiten",
    "exit_onboarding": "Onboarding overslaan",
    "login": "Inloggen",
    "logout": "Uitloggen",
    "onboarding": "Introductie",
    "onboarding_finished": "Onboarding voltooid",
    "onboarding_intro": "Onboarding introductie",
    "onboarding_quiz": "Onboarding quiz",
    "overview": "Overzicht",
    "simulation_click": "Phishingsimulatie",
    "simulations": "Simulaties",
    "videos": "Video's"
  },
  "onboarding": {
    "finished": {
      "button": "Begin met leren",
      "subtitle": "Je hebt je onboarding voltooid! Geweldig werk, je bent helemaal klaar om Moxso te gaan gebruiken. We zijn blij dat je aan boord bent en kunnen niet wachten om je te helpen jouw doelen te bereiken!",
      "title": "Dat is het!"
    },
    "intro": {
      "form": {
        "button": "Opslaan en doorgaan",
        "help": "Kies de taal die je wilt gebruiken voor jouw leerervaring.",
        "label": "Selecteer je taal",
        "placeholder": "Selecteer taal"
      },
      "header": {
        "description": "Welkom bij jouw leerplatform! We zijn blij dat je hier bent en staan klaar om je te helpen jouw doelen te bereiken. Laten we je profiel instellen en je ervaring aanpassen.",
        "title": "Welkom bij Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Voltooi deze korte quiz om ons te helpen je huidige niveau te begrijpen, zodat we de training kunnen afstemmen op jouw behoeften.",
        "title": "Wat weet je al over cyberbeveiliging?"
      }
    }
  },
  "overview": {
    "start_quiz": "Start een quiz",
    "welcome": "Welkom terug"
  },
  "partner_text": "Het Moxso-platform wordt gepresenteerd in samenwerking met {partner}.",
  "policies": {
    "cancel": {
      "text": "Dit beleid is geannuleerd door uw beheerder.",
      "title": "Geannuleerd beleid"
    },
    "continue": "Doorgaan",
    "expired": {
      "text": "Dit beleid is verlopen en is niet langer beschikbaar.",
      "title": "Verlopen beleid"
    },
    "focus": "Focus",
    "history": {
      "count": "{count} ondertekend",
      "show_less": "Minder tonen",
      "signed": "Ondertekend: {date}",
      "subtitle": "Bekijk beleidsregels die je al hebt ondertekend.",
      "title": "Ondertekende beleidsregels",
      "view_more": "Meer tonen"
    },
    "next": "Volgende",
    "overview": "Inhoudsoverzicht",
    "policy": "Beleid",
    "quiz": {
      "confirmation_card_locked": "Je moet de quiz voltooien om door te gaan",
      "subtitle": "Laat zien dat je het beleid begrijpt door deze quiz te maken.",
      "subtitle_completed": "Je hebt de quiz voltooid, bevestig het lezen van het beleid om af te ronden.",
      "title": "Quiz",
      "title_completed": "Quiz voltooid"
    },
    "reader": "Lezer",
    "signature": {
      "button": "Bevestigen",
      "checkbox_label": "Ik heb het beleid gelezen",
      "company": "Bedrijf",
      "completed": {
        "button": "Afsluiten",
        "policy_completed": "Beleid geaccepteerd",
        "subtitle": "Geweldig werk! Je hebt het beleid geaccepteerd.",
        "title": "Beleid geaccepteerd"
      },
      "ip_adress": "IP-adres",
      "subtitle": "Door te bevestigen, erken je dat je het beleid hebt gelezen en begrepen.",
      "title": "Bevestig het lezen van het beleid",
      "user_agent": "User agent"
    },
    "this_policy_doesnt_exist_in_this_language": "Dit beleid is niet beschikbaar in het Nederlands. {locale}-versie wordt weergegeven."
  },
  "quiz": {
    "analyze": {
      "text": "Analyseer deze e-mail en krijg hulp",
      "title": "Twijfel je?"
    },
    "feedback": {
      "no": "Nee",
      "text": "Was deze pagina nuttig?",
      "thanks": "Bedankt voor je feedback!",
      "yes": "Ja"
    },
    "help": {
      "button": "Volgende vraag",
      "text": "We hebben de e-mail geanalyseerd en het volgende resultaat gevonden",
      "title": "E-mailanalyse"
    },
    "intro": {
      "button": "Quiz starten",
      "text": "We gaan door 5 e-mails in jouw Moxso-inbox. Sommige e-mails kunnen van oplichters zijn die toegang proberen te krijgen tot gevoelige gegevens - je moet beslissen of de e-mail phishing is of niet. Ben je er klaar voor?",
      "title": "Klaar om te rapporteren?"
    },
    "preview": "E-mailvoorbeeld",
    "question": "Vraag {current} van {total}",
    "result": {
      "go_back": "Ga naar je overzicht",
      "mails": "E-mail gespot | E-mails gespot",
      "points": "Punten verdiend",
      "text": {
        "bad": "Helaas heb je slechts {count} e-mail correct gecategoriseerd. Maar onthoud: Oefening baart kunst! | Helaas heb je slechts {count} e-mails correct gecategoriseerd. Maar onthoud: Oefening baart kunst!",
        "good": "Je hebt {count} e-mails correct gecategoriseerd en de quiz voltooid. Ga zo door!"
      },
      "title": {
        "bad": "Volgende keer beter",
        "good": "Goed gedaan!"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "De weerbaarheidsscore meet jouw vermogen om cyberaanvallen te weerstaan. De score wordt berekend op basis van jouw gedrag in quizzen, video's, simulaties en je vaardigheden. Hoe hoger je weerbaarheidsscore, hoe beter je bent in het beschermen van jezelf en je werkplek tegen cyberaanvallen.",
    "quizzing": {
      "text": "Verbeter je prestaties in meerkeuzequizzen om je weerbaarheid te versterken.",
      "title": "Quizzen"
    },
    "show_breakdown": "Uitsplitsing tonen",
    "simulations": {
      "text": "Veilig phishinggedrag verbetert je weerbaarheid. Klik niet en vergeet niet te rapporteren!",
      "title": "Simulaties"
    },
    "skills": {
      "text": "Je vaardigheden hangen af van hoe je presteert in quizzen. Correcte antwoorden verhogen de weerbaarheid.",
      "title": "Vaardigheden"
    },
    "text": "De weerbaarheidsscore meet jouw vermogen om cyberaanvallen te weerstaan.",
    "title": "Jouw weerbaarheidsscore",
    "videos": {
      "text": "Video's zijn een belangrijk onderdeel van uw training. Verhoog de weerbaarheid door video's te bekijken.",
      "title": "Video's"
    }
  },
  "search": {
    "empty": "Zoek naar iets om te beginnen...",
    "no_results": "Geen resultaten gevonden",
    "placeholder": "Zoeken...",
    "popular": "Populaire zoekopdrachten",
    "popular_terms": ["Ransomware", "Social Engineering"]
  },
  "simulation": {
    "alert": {
      "text": "Deze e-mail maakt deel uit van een geautomatiseerde phishingoefening, dus maak je geen zorgen, het is slechts een test.",
      "title": "Dit is een phishingsimulatie"
    },
    "baseline": {
      "text": "We testen momenteel je collega's. We vragen je vriendelijk om dit bericht niet te delen.",
      "title": "Kun je een geheim bewaren?"
    },
    "branding": {
      "text": "We zijn er om te helpen, dus aarzel niet om contact op te nemen.",
      "title": "Deze oefening werd geleverd door Moxso"
    },
    "delivered_by": {
      "text": "Deze oefening werd geleverd door Moxso namens {companyName}. Als je vragen hebt, neem dan gerust contact op met {contactEmail}.",
      "title": "Over deze oefening"
    },
    "preview": "E-mailvoorbeeld",
    "resilience_score": {
      "text": "Je weerbaarheidsscore meet je vermogen om cyberaanvallen te weerstaan.",
      "title": "Jouw weerbaarheidsscore"
    },
    "submission": {
      "text": "Je hebt op een link geklikt en bent op een neppe, maar overtuigende, webpagina terechtgekomen. Bij een echte phishingaanval hadden jouw inloggegevens gestolen kunnen worden. Gelukkig was dit slechts een test.",
      "title": "Wat is er zojuist gebeurd?"
    },
    "training": {
      "button": "Start je training"
    }
  },
  "simulations": {
    "count": "Je hebt {count} simulaties van Moxso ontvangen in de afgelopen 90 dagen.",
    "empty": {
      "text": "Je hebt geen simulaties ontvangen in de afgelopen 90 dagen.",
      "title": "Geen simulaties gevonden"
    },
    "joined": "Toegetreden tot het Moxso-trainingsprogramma",
    "title": "Simulaties",
    "tooltip": {
      "click": "Je hebt op de link in deze simulatie geklikt",
      "report": "Je hebt deze simulatie gerapporteerd",
      "submit": "Je hebt ingelogd op deze simulatie."
    }
  },
  "sso": {
    "login_with": "Doorgaan met {provider}",
    "or": "of gebruik SSO",
    "redirect": "Omleiden"
  },
  "statistics": {
    "leaderboard": "Klassement",
    "missing_data": {
      "text": "Je moet punten verdienen om je rang op het klassement te zien",
      "title": "Verdien punten om jouw rang te zien"
    },
    "points_earned": "{count} punten verdiend",
    "resilience_score": "Weerbaarheidsscore"
  },
  "videos": {
    "error": "Streaming is momenteel niet beschikbaar",
    "latest": "Nieuwste video's",
    "more": "Meer bekijken",
    "not_available_in_your_locale": "Deze video is niet beschikbaar in het Nederlands. We zijn automatisch overgeschakeld naar een andere taal.",
    "play": "Video afspelen",
    "quiz": {
      "resume": "Quiz hervatten",
      "title": "Quiz"
    },
    "related": "Gerelateerde video's",
    "related_videos": "Voorgestelde video's",
    "title": "Video's",
    "watch_again": "Opnieuw bekijken"
  }
}
